import { useEffect } from 'react';

import { GeoJSONGeometry } from '@atom/types/geojson';
import { BoundingBoxSubjectType } from '@atom/types/map';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import useTaskBoundingBox from './hooks/useTaskBoundingBox';

export type TaskFrameConfig = {
  subjectType: BoundingBoxSubjectType;
  taskId?: string;
  workOrderId?: string;
  /** When false, the task bounding-box frame is skipped. */
  active?: boolean;
  /** Change this to re-frame the camera. */
  frameKey?: string | number;
  /** Frame a single location's geometry instead of the task bounding box. */
  locationGeometry?: GeoJSONGeometry | null;
};

/**
 * Frames the map camera to a task's bounding box (or a single location).
 */
const TaskBoundingBoxFramer = ({
  subjectType,
  taskId,
  workOrderId,
  active = true,
  frameKey,
  locationGeometry = null,
}: TaskFrameConfig) => {
  const { frameBoundingBox, frameLocation } = useTaskBoundingBox(subjectType);

  useEffect(() => {
    if (active && taskId && workOrderId) {
      frameBoundingBox({ taskId, workOrderId });
    }
  }, [active, taskId, workOrderId, frameKey, frameBoundingBox]);

  useEffect(() => {
    if (!isNilOrEmpty(locationGeometry)) {
      frameLocation(locationGeometry);
    }
  }, [locationGeometry, frameLocation]);

  return null;
};

export default TaskBoundingBoxFramer;
